import React, { useContext, useEffect, useState } from 'react';
import { getAuthorizedPersonsProfile } from '../../../actions';
import { Context } from '../../../defaults';
import { Table } from 'antd';
const SchoolTeachers = () => {
    const { dictionary, language } = useContext(Context);
    const [teachers, setTeachers] = useState();

    useEffect(() => {
        getAuthorizedPersonsProfile().then(({ data }) => setTeachers(data.institution.teachers));
    }, []);

    const columns = [
        {
            title: dictionary?.LastName[language],
            dataIndex: 'lastName',
            key: 'lastName',
        },
        {
            title: dictionary?.FirstName[language],
            dataIndex: 'firstName',
            key: 'firstName',
        },
        {
            title: dictionary?.MiddleName[language],
            dataIndex: 'middleName',
            key: 'middleName',
        },
        {
            title: dictionary?.Phone[language],
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: dictionary?.Status[language],
            dataIndex: 'status',
            key: 'status',
        },
        // {
        //     title: 'classId',
        //     dataIndex: 'classId',
        //     key: 'classId',
        // },
        // {
        //     title: 'UserId',
        //     dataIndex: 'userId',
        //     key: 'userId',
        // },
    ];


    return (
        <React.Fragment>
            <Table columns={columns} dataSource={teachers} rowKey="teachers" />
        </React.Fragment>
    );
};
export default SchoolTeachers